const SCREEN = { monthly_pdf: 'ניהול ← עדכון חודשי', master: 'ניהול ← לקוח חדש' };
export const HEBREW_MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
/** 2009-11-30 → 30/11/2009 */
export const fmtDate = (iso) => iso.split('-').reverse().join('/');
/** 2009-01 → ינואר 2009 */
const fmtMonth = (ym) => `${HEBREW_MONTHS[Number(ym.slice(5, 7)) - 1]} ${ym.slice(0, 4)}`;
/** "החודש מרץ 2025" / "החודשים ינואר–יולי 2025" — singular only for one month on its own. */
const monthsNoun = (months) => `${months.length === 1 ? 'החודש' : 'החודשים'} ${fmtMonths(months)}`;
const rowList = (rows) => (rows.length === 1 ? `שורה ${rows[0]}` : `שורות ${rows.join(', ')}`);
/** Consecutive months collapse to a range: [2009-01 … 2009-07] → "ינואר–יולי 2009". */
export function fmtMonths(months) {
    const runs = [];
    for (const m of [...months].sort()) {
        const last = runs.at(-1)?.at(-1);
        const next = last && nextMonth(last) === m;
        if (next)
            runs.at(-1).push(m);
        else
            runs.push([m]);
    }
    return runs
        .map((r) => {
        if (r.length === 1)
            return fmtMonth(r[0]);
        const [a, b] = [r[0], r.at(-1)];
        return a.slice(0, 4) === b.slice(0, 4)
            ? `${HEBREW_MONTHS[Number(a.slice(5)) - 1]}–${fmtMonth(b)}`
            : `${fmtMonth(a)} – ${fmtMonth(b)}`;
    })
        .join(', ');
}
function nextMonth(ym) {
    const [y, m] = ym.split('-').map(Number);
    return m === 12 ? `${y + 1}-01` : `${y}-${String(m + 1).padStart(2, '0')}`;
}
/** The template for one kind of fact. */
export function renderMessage(facts) {
    return { ...templateFor(facts), source: 'template' };
}
function templateFor(facts) {
    const f = facts;
    switch (f.kind) {
        case 'wrong_file_type': {
            if (f.screen === 'monthly_pdf') {
                const what = f.found === 'excel' ? 'קובץ Excel' : 'אינו קובץ PDF';
                return {
                    facts,
                    title: f.found === 'excel' ? `"${f.filename}" הוא ${what}, ולא דוח PDF` : `"${f.filename}" ${what}`,
                    body: `במסך "${SCREEN.monthly_pdf}" מעלים רק דוחות PDF חודשיים מבתי ההשקעות. הקובץ לא נקרא ולא נשמר.`,
                    steps: [
                        `קובץ מאסטר של לקוח (Excel) מעלים במסך "${SCREEN.master}", עם מזהה הלקוח הקיים — ההעלאה מעדכנת את הלקוח.`,
                        'כאן העלו רק את קובצי ה-PDF של החודש.',
                    ],
                };
            }
            return {
                facts,
                title: f.found === 'pdf' ? `"${f.filename}" הוא קובץ PDF, ולא קובץ מאסטר (Excel)` : `"${f.filename}" אינו קובץ Excel`,
                body: `במסך "${SCREEN.master}" מעלים את קובץ ה-Excel של הלקוח. הקובץ לא נקרא ולא נשמר.`,
                steps: [`דוחות PDF חודשיים מבתי ההשקעות מעלים במסך "${SCREEN.monthly_pdf}".`, 'כאן בחרו את קובץ ה-Excel של הלקוח.'],
            };
        }
        case 'repeated_dates': {
            const lines = f.repeats.map((r) => (r.rows.length > 0 ? `${fmtDate(r.date)} — ${rowList(r.rows)}` : fmtDate(r.date)));
            const back = f.backwards.map((b) => b.row > 0
                ? `אחרי ${fmtDate(b.previous_date)} (שורה ${b.previous_row}) הטבלה חוזרת אחורה ל-${fmtDate(b.date)} (שורה ${b.row})`
                : `אחרי ${fmtDate(b.previous_date)} הטבלה חוזרת אחורה ל-${fmtDate(b.date)}`);
            const missing = f.missing_months.length > 0 ? `${f.missing_months.length === 1 ? 'חסר' : 'חסרים'} בטבלה ${monthsNoun(f.missing_months)}.` : '';
            return {
                facts,
                title: `בגיליון "${f.sheet}" אותם תאריכים מופיעים ביותר משורה אחת`,
                body: [
                    `בטבלת התשואות (עמודה A) אותו תאריך רשום כמה פעמים: ${lines.join('; ')}.`,
                    back.length > 0 ? `${back.join('; ')}.` : '',
                    missing,
                    'נראה שהשנה או החודש הוקלדו לא נכון בשורות האלה. אין בגיליון דרך לדעת איזו שורה נכונה, ולכן הקובץ לא נקלט.',
                ]
                    .filter(Boolean)
                    .join(' '),
                steps: [
                    `פתחו את הגיליון "${f.sheet}" ותקנו את התאריכים בעמודה A, כך שכל שורה תהיה חודש אחד אחרי הקודמת.`,
                ],
            };
        }
        case 'fund_in_two_sheets':
            return {
                facts,
                title: `הקרן "${f.fund}" נקראת משני גיליונות`,
                body: `הגיליונות ${f.sheets.map((s) => `"${s}"`).join(' ו-')} מתפרשים שניהם כקרן "${f.fund}", ולשניהם יש שורה לתאריך ${fmtDate(f.date)}. לקרן יש רק שורה אחת לכל תאריך, ולכן הקובץ לא נקלט.`,
                steps: ['מחקו את הגיליון הכפול, או שנו את שם אחד הגיליונות כך שיתאר קרן אחרת.'],
            };
        case 'date_order': {
            const gaps = f.missing_months.length;
            const parts = [
                f.backwards.length > 0
                    ? `התאריכים חוזרים אחורה: ${f.backwards.map((b) => (b.row > 0 ? `שורה ${b.row} (${fmtDate(b.date)}) אחרי שורה ${b.previous_row} (${fmtDate(b.previous_date)})` : `${fmtDate(b.date)} אחרי ${fmtDate(b.previous_date)}`)).join('; ')}.`
                    : '',
                gaps > 0 ? `אין שורה ל${gaps === 1 ? 'חודש' : 'חודשים'} ${fmtMonths(f.missing_months)}.` : '',
                // Only a gap costs a month in the reports; rows out of order all load.
                gaps > 0
                    ? `הקובץ נקלט, אבל ${gaps === 1 ? 'החודש הזה לא יופיע' : 'החודשים האלה לא יופיעו'} בדוחות של הקרן.`
                    : 'הקובץ נקלט וכל השורות נקראו, אבל תאריך שקופץ אחורה הוא לרוב טעות הקלדה — כדאי לוודא שהתאריכים נכונים.',
            ];
            return {
                facts,
                title: gaps > 0 ? `בגיליון "${f.sheet}" חסרים חודשים` : `בגיליון "${f.sheet}" התאריכים לא לפי הסדר`,
                body: parts.filter(Boolean).join(' '),
                steps: gaps > 0
                    ? ['אם החודשים קיימים — הוסיפו או תקנו אותם בגיליון והעלו שוב.', 'אם הקרן באמת לא פעלה בחודשים האלה, אין צורך לעשות דבר.']
                    : ['בדקו את התאריכים בשורות האלה. אם יש טעות — תקנו והעלו שוב.'],
            };
        }
        case 'summary_sheet_not_read': {
            const what = `בגיליון "${f.expected_sheet}" הצוות רושם את התשואה החודשית של כל התיק, כולל תיקונים ידניים.`;
            const consequence = 'לכן התשואה החודשית של התיק חושבה מהקרנות, בלי התיקונים הידניים. הקובץ נקלט.';
            // Rows under a recognisable date row are found by their names, or — when
            // the names are different — proposed for the admin to confirm on upload.
            // What is left to fix in the file is the date row itself.
            const fixIt = 'ודאו שהתאריכים החודשיים כתובים בשורה אחת בראש הגיליון, ושורות התשואה החודשית והמצטברת מתחתיהם, והעלו שוב. אם שמות השורות שונים מהרגיל, המערכת תציע אילו שורות לקרוא ותבקש את אישורכם.';
            if (f.reason === 'no_monthly_values') {
                return {
                    facts,
                    title: `בגיליון "${f.expected_sheet}" לא נמצאה תשואה חודשית`,
                    body: `${what} הגיליון נמצא, אבל לא נקרא ממנו אף ערך של תשואה חודשית. ${consequence}`,
                    steps: [fixIt],
                };
            }
            return {
                facts,
                title: 'גיליון הסיכום לא נקרא',
                body: `${what} בקובץ יש ${f.similar_sheets.map((s) => `"${s}"`).join(', ')}, אבל לא נמצאה ${f.similar_sheets.length === 1 ? 'בו' : 'באף אחד מהם'} שורת תאריכים עם תשואה חודשית מתחתיה. ${consequence}`,
                steps: [`אם ${f.similar_sheets.length === 1 ? 'זה' : 'אחד מאלה הוא'} גיליון הסיכום — ${fixIt}`, 'אם לא — אין צורך לעשות דבר.'],
            };
        }
    }
}
/**
 * Numbers in a message that its facts do not contain — an invented row, date
 * or month. Empty means every number in the text is backed by the facts.
 *
 * The gate for any text built from facts, however it was written: a template
 * must pass it, and so must a model's phrasing, which is thrown away if not.
 */
export function unsupportedNumbers(message) {
    const numbersIn = (s) => (s.match(/\d+/g) ?? []).map((n) => String(Number(n)));
    const allowed = new Set(numbersIn(JSON.stringify(message.facts)));
    const text = [message.title, message.body, ...message.steps].join(' ');
    return [...new Set(numbersIn(text))].filter((n) => !allowed.has(n));
}
//# sourceMappingURL=uploadMessages.js.map